export const translations = {
  de: {
    // Navigation
    nav: {
      home: 'Home',
      windsurfing: 'Windsurfing',
      kitesurfing: 'Kitesurfing',
      wingfoiling: 'Wingfoiling',
      center: 'Center & Team',
      news: 'News',
      hotels: 'Hotels',
      prices: 'Preise',
      contact: 'Kontakt',
      booking: 'Buchung',
      admin: 'Admin'
    },
    // Home Page
    home: {
      hero_title: 'Willkommen bei Surfmotion',
      hero_subtitle: 'Dein Premium Wassersport-Center in Soma Bay',
      hero_cta: 'Vorab-Registrierung',
      latest_news: 'Aktuelle News',
      view_all: 'Alle ansehen',
      activities: 'Unsere Aktivitäten',
      why_us: 'Warum Surfmotion?',
      quality: 'Beste Qualität',
      quality_desc: 'Top Equipment und professionelle Betreuung',
      safety: 'Sicherheit',
      safety_desc: 'Getrennte Bereiche für verschiedene Levels',
      location: 'Traumlage',
      location_desc: 'Perfekte Windverhältnisse in Soma Bay',
      region_title: 'Die Region',
      region_subtitle: 'Soma Bay - Dein Wassersport-Paradies am Roten Meer',
      region_desc: 'Soma Bay liegt an der ägyptischen Küste des Roten Meeres, etwa 45 km südlich von Hurghada und nur wenige Kilometer von der Hafenstadt Port Safaga entfernt. Die Halbinsel ist bekannt für ihre erstklassigen Windverhältnisse, die konstant von März bis November wehen und Soma Bay zu einem der besten Spots für Windsurfen, Kitesurfen und Wingfoiling in ganz Ägypten machen. Die geschützte Bucht mit ihrem flachen, türkisfarbenen Wasser bietet ideale Bedingungen für Anfänger, während erfahrene Surfer die anspruchsvolleren Bereiche außerhalb der Lagune genießen können.',
      hurghada_title: 'Hurghada & Umgebung',
      hurghada_desc: 'Die lebendige Stadt Hurghada ist nur 45 Minuten entfernt und bietet alles, was das Herz begehrt: Restaurants, Shopping-Möglichkeiten, traditionelle Märkte und ein pulsierendes Nachtleben. Von hier aus starten auch Tauchsafaris zu den weltberühmten Tauchspots des Roten Meeres. Port Safaga, noch näher gelegen, ist ein authentisches ägyptisches Küstenstädtchen mit hervorragenden Fischrestaurants und einem entspannten Ambiente.',
      activities_title: 'Aktivitäten rund um Soma Bay',
      activities_desc: 'Sollte der Wind einmal Pause machen – was selten vorkommt – bietet die Region zahlreiche alternative Aktivitäten: Schnorcheln und Tauchen an einigen der schönsten Korallenriffe der Welt, Quad-Touren durch die Wüste, Kamelritte bei Sonnenuntergang, Besuche in traditionellen Beduinencamps, Stand-Up-Paddling, oder einfach entspannen an den traumhaften Sandstränden.',
      sports_title: 'Wassersport am Roten Meer',
      windsurfing_info: 'Windsurfen ist der Klassiker unter den Brettsportarten und bietet puren Spaß auf dem Wasser. In Soma Bay erwarten dich perfekte Bedingungen: konstante Winde zwischen 15-25 Knoten, flaches Wasser in der Lagune für Anfänger und Aufsteiger, sowie anspruchsvolle Bedingungen außerhalb für Freerider. Unsere erfahrenen VDWS-zertifizierten Lehrer bringen dir vom ersten Aufsteigen auf das Brett bis hin zu spektakulären Manövern alles bei.',
      kitesurfing_info: 'Kitesurfen vereint die Faszination des Fliegens mit der Dynamik des Surfens. Der große Stehbereich in Soma Bay macht das Lernen besonders einfach und sicher. Mit unserem strukturierten Schulungsprogramm nach IKO-Standards wirst du schnell Fortschritte machen. Von den ersten Schritten mit dem Kite bis zu deinen ersten geglückten Sprüngen – wir begleiten dich auf deinem Weg.',
      wingfoiling_info: 'Wingfoiling ist die neueste Revolution im Wassersport! Diese innovative Sportart kombiniert Elemente aus Windsurfen, Kitesurfen und Foilen. Mit einem Handheld-Wing in den Händen und einem Foil unter dem Board schwebst du förmlich über dem Wasser. Der Einstieg ist überraschend einfach und die Lernkurve steil – viele unserer Schüler gleiten bereits nach wenigen Stunden über die Bucht. Soma Bay ist dank der moderaten Winde und des flachen Wassers ein perfekter Ort, um Wingfoiling zu lernen.',
      climate_title: 'Klima & beste Reisezeit',
      climate_desc: 'Soma Bay bietet ganzjährig angenehmes Klima mit über 300 Sonnentagen im Jahr. Die Hauptsaison für Wassersport ist von März bis November, wenn die Temperaturen zwischen 25-35°C liegen und der Wind am zuverlässigsten ist. Aber auch in den Wintermonaten herrschen milde Temperaturen um 20-25°C – perfekt für alle, die dem europäischen Winter entfliehen möchten. Die Wassertemperatur bleibt das ganze Jahr über angenehm bei 22-28°C.'
    },
    // Windsurfing Page
    windsurfing: {
      title: 'Windsurfing',
      subtitle: 'Perfekte Bedingungen für alle Levels',
      spot_title: 'Der Spot',
      spot_desc: 'Unser Windsurfing-Spot bietet ideale Bedingungen mit großem Stehbereich, geschützter Lagune für Anfänger und separaten Bereichen für Freerider. Die Sicherheit steht bei uns an erster Stelle.',
      beginner: 'Anfänger',
      beginner_desc: 'Geschützte Lagune mit Stehbereich',
      advanced: 'Fortgeschrittene',
      advanced_desc: 'Separate Freeride-Zone',
      equipment: 'Equipment',
      equipment_desc: 'Neuestes Material von Top-Marken',
      location_title: 'Lage',
      location_desc: 'Nur 4 Stunden Flug trennen euch von Deutschland und unserem Surfcenter. Nach der Landung und einer Fahrt von etwa 50km erreicht Ihr einen der besten Surfspots der Welt. Gelegen sind wir naehe der Küstenstadt Port Safaga, ihr findet hier eine Menge Hotels, von Luxus bis zu Low Budget Angeboten. Auch Ferienwohnungen oder Privatzimmer sind zu finden. Sollte mal der Wind ausbleiben gibt es eine Menge Aktivitäten zu unternehmen, wie Tauchen, Quadsafari, SUP und vieles mehr.',
      wind_title: 'Wind',
      wind_desc: 'Die im Norden gelegene Landzunge bietet einen Flugzeugflügeleffekt, wodurch der Wind um rund eine halbe bis ganze Windstärke verstärkt wird. Ansonsten weht bei uns der in Ägypten bekannte Frühwind, der bis 10/11 Uhr schräg ablandig bläst und sich danach auf sideshore mit höheren Windstärken stabilisiert und damit in perfektem Winkel über die Sandbank streicht. Bis 14/15 Uhr hat man meist einen sehr beständigen Wind, der danach – je nach Jahreszeit – langsam abflaut, oder auch bis kurz vor Sonnenuntergang durchblasen kann.',
      safety_title: 'Sicherheit',
      safety_desc: 'Auch die Sicherheit nimmt bei uns eine sehr wichtige Position ein. Aufgrund der Größe unseres Spots konnten wir ihn in zwei Bereiche teilen, in den Beginner und Teaching Bereich und den Freeride Bereich. Desweiteren teilen wir ihn in den Bereich für Kitesurfer und Windsurfer, somit können wir gewährleisten das sich keiner in die Quere kommt, und das Unfallrisiko zwischen Kite und Windsurfer auf ein Minimum reduzieren. Falls es doch einmal Schwierigkeiten gibt sind wir mit unseren Rescueboats sofort zur Stelle.',
      school_title: 'Unsere Schule',
      school_desc: 'Du willst mit Spaß und Sicherheit das Windsurfen lernen? Ihr wollt eine professionelle Betreuung, die auf Eure Bedürfnisse individuell zugeschnitten ist? Dann seid Ihr bei uns genau richtig! Unsere Surfschule befindet sich direkt am Strand, einem der Topspots in Ägypten, der für Windsurfer aller Könnensklassen perfekte Bedingungen bietet. Hier erwarten Euch hoch motivierte Windsurflehrer, denen vor allem Eure Sicherheit, Euer Wohl und Lernerfolg am Herzen liegt. Neugierig? Dann schaut Euch doch ein wenig um…',
      courses_title: 'Unsere Kurse',
      courses_desc: 'Unsere Schulungen orientieren sich an drei Punkten: Den Richtlinien des VDWS, den speziellen Eigenschaften des Spots und Euren individuellen Bedürfnissen. Gerade letzteres bietet Euch einen enormen Vorteil. Unsere Schulungen sind in Module aufgeteilt. Damit könnt Ihr sicher sein, dass die Lehrinhalte Eurem Können entsprechen, ein schneller Fortschritt garantiert ist und Ihr auch nur das bezahlt, was Du wirklich brauchst. Ich hoffe wir konnten dich neugierig machen und sehen dich bald bei uns…'
    },
    // Kitesurfing Page
    kitesurfing: {
      title: 'Kitesurfing',
      subtitle: 'Wind und Wellen für perfektes Kiten',
      description: 'Soma Bay bietet optimale Bedingungen für Kitesurfer. Konstante Winde und separate Bereiche sorgen für ein sicheres und unvergessliches Erlebnis.',
      safety: 'Sicherheitsbereiche',
      safety_desc: 'Getrennte Zonen für Kiter und Windsurfer',
      courses: 'Kurse',
      courses_desc: 'Vom Anfänger bis zum Profi',
      rental: 'Verleih',
      rental_desc: 'Top Equipment für alle Levels',
      spot_title: 'Spot',
      spot_desc: 'Auch für Euch Kiter bieten wir einen perfekten Spot mit viel Platz. Auf der Luv-Seite unserer Station, ca 20 m vom Strand entfernt erstreckt sich ein 2 km langer und ca. 600 m breiter Stehbereich, der je nach Tidenstand 30 cm bis zu 60 cm tief wird. Das hüfttiefe Wasser sorgt dann für wirklich angenehme und sichere erste Kiteversuche, die ersten Fahrversuche, lernen des Höhe Laufens oder der ersten Cool Moves. Bei Ebbe liegt ein Teil der Sandbank für ca. 2 ½ Stunden trocken. Doch auch in dieser Zeit habt Ihr hinter des Stehbereiches ein ganzes Kiterevier für Euch. Unser Kitelager bietet jede Menge Unterbringungsmöglichkeiten für Euer Material. Mit unserem Kompressor könnt Ihr Euch das Pumpen ersparen. Und auch zum Auf- und Abbau oder einfach nur zum Lagern während Pausen findet Ihr jede Menge Platz ohne das Ihr unseren Surfern in die Quere kommt.',
      safety_title: 'Sicherheit',
      safety_detail: 'Auch die Sicherheit nimmt bei uns eine sehr wichtige Position ein. Aufgrund der Größe unseres Spots konnten wir ihn in zwei Bereiche teilen, in den Beginner und Teaching Bereich und den Freeride Bereich. Desweiteren teilen wir ihn in den Bereich für Kitesurfer und Windsurfer, somit können wir gewährleisten das sich keiner in die Quere kommt, und das Unfallrisiko zwischen Kite und Windsurfer auf ein Minimum reduzieren. Falls es doch einmal Schwierigkeiten gibt sind wir mit unseren Rescueboats sofort zur Stelle.',
      school_title: 'Unsere Schule',
      school_desc: 'Du willst mit Spaß und Sicherheit das Kiten lernen? Ihr wollt eine professionelle Betreuung, die auf Eure Bedürfnisse individuell zugeschnitten ist? Dann seid Ihr bei uns genau richtig! Unsere Kiteschule befindet sich direkt am Strand, einem der Topspots in Ägypten, der für Kitesurfer aller Könnensklassen perfekte Bedingungen bietet. Hier erwarten Euch hoch motivierte Kitelehrer, denen vor allem Eure Sicherheit, Euer Wohl und Lernerfolg am Herzen liegt. Neugierig? Dann schaut Euch doch ein wenig um…',
      courses_title: 'Unsere Kurse',
      courses_detail: 'Unsere Schulungen orientieren sich an drei Punkten: Den Richtlinien des VDWS und IKO, den speziellen Eigenschaften des Spots und Euren individuellen Bedürfnissen. Gerade letzteres bietet Euch einen enormen Vorteil. Unsere Schulungen sind in Module aufgeteilt. Damit könnt Ihr sicher sein, dass die Lehrinhalte Eurem Können entsprechen, ein schneller Fortschritt garantiert ist und Ihr auch nur das bezahlt, was Du wirklich brauchst. Ich hoffe wir konnten dich neugierig machen und sehen dich bald bei uns.'
    },
    // Wingfoiling Page
    wingfoiling: {
      title: 'Wingfoiling',
      subtitle: 'Der neueste Trendsport',
      description: 'Entdecke Wingfoiling - die perfekte Kombination aus Windsurfen, Kitesurfen und Surfen. Ideal für alle, die etwas Neues ausprobieren möchten.',
      learn: 'Lernen',
      learn_desc: 'Schneller Einstieg mit unseren Profis',
      gear: 'Material',
      gear_desc: 'Neuestes Wingfoiling-Equipment',
      about_title: 'Das Wing Foil',
      about_desc: 'Das Wing Foil ist die neueste Entwicklung im Bereich der Boardsportarten. Dabei wird ein mit beiden Händen gehaltener Flügel („Wing") mit einem Hydrofoil, das auf einem kurzen SUP-Brett montiert ist, manipuliert. Es ist eine Praxis, die zwischen Windsurffoil, Kite Foil und SUP Foil angesiedelt ist. Der Wing ist ähnlich aufgebaut wie ein Kite, wird allerdings wie beim Windsurfen direkt am Körper gehalten. Am beliebtesten ist das Wingsurfen mit einem Foilboard. Durch eine Verlängerung („Mast") werden Tragflächen an dem Board angebracht, durch die der Surfer bei genügend Geschwindigkeit aus dem Wasser abhebt.',
      safety_title: 'Sicherheit',
      safety_desc: 'Auch die Sicherheit nimmt bei uns eine sehr wichtige Position ein. Aufgrund der Größe unseres Spots konnten wir ihn in zwei Bereiche teilen, in den Beginner und Teaching Bereich und den Freeride Bereich. Desweiteren teilen wir ihn in den Bereich für Kitesurfer und Windsurfer, somit können wir gewährleisten das sich keiner in die Quere kommt, und das Unfallrisiko zwischen Kite und Windsurfer auf ein Minimum reduzieren. Falls es doch einmal Schwierigkeiten gibt sind wir mit unseren Rescueboats sofort zur Stelle.',
      school_title: 'Unsere Schule',
      school_desc: 'Du willst mit Spaß und Sicherheit das Wingfoilen lernen? Ihr wollt eine professionelle Betreuung, die auf Eure Bedürfnisse individuell zugeschnitten ist? Dann seid Ihr bei uns genau richtig! Unsere Schule befindet sich direkt am Strand, einem der Topspots in Ägypten, der für Wingsurfer, Kitesurfer, Windsurfer aller Könnensklassen perfekte Bedingungen bietet. Hier erwarten Euch hoch motivierte Lehrer, denen vor allem Eure Sicherheit, Euer Wohl und Lernerfolg am Herzen liegt. Neugierig? Dann schaut Euch doch ein wenig um…',
      courses_title: 'Unsere Kurse',
      courses_desc: 'Unsere Schulungen orientieren sich an drei Punkten: Den Richtlinien des VDWS und IKO, den speziellen Eigenschaften des Spots und Euren individuellen Bedürfnissen. Gerade letzteres bietet Euch einen enormen Vorteil. Unsere Schulungen sind in Module aufgeteilt. Damit könnt Ihr sicher sein, dass die Lehrinhalte Eurem Können entsprechen, ein schneller Fortschritt garantiert ist und Ihr auch nur das bezahlt, was Du wirklich brauchst. Ich hoffe wir konnten dich neugierig machen und sehen dich bald bei uns…'
    },
    // Center & Team
    center: {
      title: 'Center & Team',
      subtitle: 'Mehr als nur ein Wassersport-Center',
      about: 'Über uns',
      about_desc: 'Surfmotion Soma Bay ist dein Premium-Center für Windsurfing, Kitesurfing und Wingfoiling. Seit Jahren bieten wir professionelle Kurse und erstklassiges Equipment.',
      facilities: 'Unsere Einrichtungen',
      facilities_desc: 'Moderne Ausstattung, Umkleiden, Duschen, Aufenthaltsbereich',
      team: 'Unser Team',
      team_desc: 'Erfahrene und zertifizierte Instruktoren'
    },
    // News Page
    newsPage: {
      title: 'News & Events',
      subtitle: 'Bleib auf dem Laufenden',
      filter_all: 'Alle',
      filter_news: 'News',
      filter_events: 'Events',
      filter_updates: 'Updates',
      read_more: 'Weiterlesen',
      published_on: 'Veröffentlicht am'
    },
    // Hotels Page
    hotels: {
      title: 'Unterkunft',
      subtitle: 'Unsere Partner-Hotels in Soma Bay',
      description: 'Wir arbeiten mit den besten Hotels in Soma Bay zusammen, um dir den perfekten Aufenthalt zu ermöglichen.',
      amenities: 'Ausstattung',
      book_now: 'Jetzt buchen'
    },
    // Prices Page
    prices: {
      title: 'Preise',
      subtitle: 'Transparente Preise für alle Aktivitäten',
      course: 'Kurs',
      rental: 'Verleih',
      per_hour: 'pro Stunde',
      per_day: 'pro Tag',
      per_week: 'pro Woche',
      beginner_course: 'Anfängerkurs',
      advanced_course: 'Fortgeschrittenenkurs',
      private_lesson: 'Privatstunde',
      equipment_rental: 'Equipment-Verleih'
    },
    // Contact Page
    contact: {
      title: 'Kontakt',
      subtitle: 'Wir freuen uns von dir zu hören',
      name: 'Name',
      email: 'E-Mail',
      subject: 'Betreff',
      message: 'Nachricht',
      send: 'Senden',
      sending: 'Wird gesendet...',
      success: 'Nachricht erfolgreich gesendet!',
      error: 'Fehler beim Senden. Bitte versuche es erneut.',
      info: 'Kontaktinformationen',
      address: 'Adresse',
      phone: 'Telefon',
      email_label: 'E-Mail'
    },
    // Booking Page
    booking: {
      title: 'Buchung',
      subtitle: 'Buche dein Wassersport-Erlebnis',
      activity: 'Aktivität',
      date: 'Datum',
      level: 'Level',
      level_beginner: 'Anfänger',
      level_intermediate: 'Fortgeschritten',
      level_advanced: 'Profi',
      phone: 'Telefon (optional)',
      additional_info: 'Zusätzliche Informationen',
      submit: 'Buchung anfragen',
      submitting: 'Wird gesendet...',
      success: 'Buchungsanfrage erfolgreich! Wir melden uns in Kürze.',
      error: 'Fehler bei der Buchung. Bitte versuche es erneut.'
    },
    // Admin
    admin: {
      login: 'Login',
      username: 'Benutzername',
      password: 'Passwort',
      login_button: 'Anmelden',
      logout: 'Abmelden',
      dashboard: 'Dashboard',
      news_management: 'News verwalten',
      bookings: 'Buchungen',
      contacts: 'Kontaktanfragen',
      images: 'Bilder',
      settings: 'Einstellungen'
    },
    // Common
    common: {
      loading: 'Lädt...',
      error: 'Fehler',
      success: 'Erfolgreich',
      cancel: 'Abbrechen',
      save: 'Speichern',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      create: 'Erstellen',
      back: 'Zurück'
    }
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      windsurfing: 'Windsurfing',
      kitesurfing: 'Kitesurfing',
      wingfoiling: 'Wingfoiling',
      center: 'Center & Team',
      news: 'News',
      hotels: 'Hotels',
      prices: 'Prices',
      contact: 'Contact',
      booking: 'Booking',
      admin: 'Admin'
    },
    // Home Page
    home: {
      hero_title: 'Welcome to Surfmotion',
      hero_subtitle: 'Your Premium Watersports Center in Soma Bay',
      hero_cta: 'Pre-Registration',
      latest_news: 'Latest News',
      view_all: 'View All',
      activities: 'Our Activities',
      why_us: 'Why Surfmotion?',
      quality: 'Best Quality',
      quality_desc: 'Top equipment and professional support',
      safety: 'Safety',
      safety_desc: 'Separate areas for different levels',
      location: 'Dream Location',
      location_desc: 'Perfect wind conditions in Soma Bay',
      region_title: 'The Region',
      region_subtitle: 'Soma Bay - Your Watersports Paradise on the Red Sea',
      region_desc: 'Soma Bay is located on the Egyptian coast of the Red Sea, about 45 km south of Hurghada and just a few kilometers from the port city of Port Safaga. The peninsula is known for its world-class wind conditions, which blow consistently from March to November, making Soma Bay one of the best spots for windsurfing, kitesurfing and wingfoiling in all of Egypt. The sheltered bay with its shallow, turquoise water offers ideal conditions for beginners, while experienced surfers can enjoy the more challenging areas outside the lagoon.',
      hurghada_title: 'Hurghada & Surroundings',
      hurghada_desc: 'The vibrant city of Hurghada is only 45 minutes away and offers everything your heart desires: restaurants, shopping opportunities, traditional markets and a pulsating nightlife. Diving safaris to the world-famous dive sites of the Red Sea also depart from here. Port Safaga, even closer, is an authentic Egyptian coastal town with excellent fish restaurants and a relaxed atmosphere.',
      activities_title: 'Activities around Soma Bay',
      activities_desc: 'Should the wind take a break – which rarely happens – the region offers numerous alternative activities: snorkeling and diving at some of the most beautiful coral reefs in the world, quad tours through the desert, camel rides at sunset, visits to traditional Bedouin camps, stand-up paddling, or simply relaxing on the beautiful sandy beaches.',
      sports_title: 'Watersports on the Red Sea',
      windsurfing_info: 'Windsurfing is the classic among board sports and offers pure fun on the water. In Soma Bay you can expect perfect conditions: consistent winds between 15-25 knots, flat water in the lagoon for beginners and improvers, as well as challenging conditions outside for freeriders. Our experienced VDWS-certified instructors will teach you everything from your first time on the board to spectacular maneuvers.',
      kitesurfing_info: 'Kitesurfing combines the fascination of flying with the dynamics of surfing. The large standing area in Soma Bay makes learning particularly easy and safe. With our structured training program according to IKO standards, you will make rapid progress. From your first steps with the kite to your first successful jumps – we accompany you on your journey.',
      wingfoiling_info: 'Wingfoiling is the latest revolution in watersports! This innovative sport combines elements of windsurfing, kitesurfing and foiling. With a handheld wing in your hands and a foil under the board, you literally float above the water. Getting started is surprisingly easy and the learning curve is steep – many of our students glide across the bay after just a few hours. Thanks to moderate winds and flat water, Soma Bay is a perfect place to learn wingfoiling.',
      climate_title: 'Climate & Best Time to Visit',
      climate_desc: 'Soma Bay offers a pleasant climate year-round with over 300 days of sunshine per year. The main season for watersports is from March to November, when temperatures range between 25-35°C and the wind is most reliable. But even in the winter months, mild temperatures of 20-25°C prevail – perfect for those who want to escape the European winter. The water temperature remains pleasant throughout the year at 22-28°C.'
    },
    // Windsurfing Page
    windsurfing: {
      title: 'Windsurfing',
      subtitle: 'Perfect conditions for all levels',
      spot_title: 'The Spot',
      spot_desc: 'Our windsurfing spot offers ideal conditions with a large standing area, protected lagoon for beginners, and separate areas for freeriders. Safety is our top priority.',
      beginner: 'Beginners',
      beginner_desc: 'Protected lagoon with standing area',
      advanced: 'Advanced',
      advanced_desc: 'Separate freeride zone',
      equipment: 'Equipment',
      equipment_desc: 'Latest gear from top brands',
      location_title: 'Location',
      location_desc: 'Only a 4-hour flight separates you from Germany and our surf center. After landing and a drive of about 50km, you will reach one of the best surf spots in the world. We are located near the coastal town of Port Safaga, where you will find many hotels, from luxury to budget options. Holiday apartments and private rooms are also available. If the wind fails, there are plenty of activities to enjoy, such as diving, quad safaris, SUP, and much more.',
      wind_title: 'Wind',
      wind_desc: 'The northern promontory provides an airplane wing effect, which increases the wind by about half to a full wind force. Otherwise, we have the early morning wind known in Egypt, which blows diagonally offshore until 10/11 am and then stabilizes on sideshore with higher wind forces, sweeping over the sandbank at the perfect angle. Until 2/3 pm, you usually have very consistent wind, which then – depending on the season – slowly decreases or can continue blowing until shortly before sunset.',
      safety_title: 'Safety',
      safety_desc: 'Safety also takes a very important position with us. Due to the size of our spot, we were able to divide it into two areas: the beginner and teaching area and the freeride area. Furthermore, we divide it into the area for kitesurfers and windsurfers, so we can ensure that no one gets in each other\'s way, and the risk of accidents between kite and windsurfer is reduced to a minimum. If there are any difficulties, we are immediately on hand with our rescue boats.',
      school_title: 'Our School',
      school_desc: 'Do you want to learn windsurfing with fun and safety? Do you want professional support that is individually tailored to your needs? Then you are in the right place! Our surf school is located directly on the beach, one of the top spots in Egypt, which offers perfect conditions for windsurfers of all skill levels. Here you can expect highly motivated windsurf instructors who care about your safety, well-being and learning success. Curious? Then take a look around…',
      courses_title: 'Our Courses',
      courses_desc: 'Our training is based on three points: The guidelines of VDWS, the special characteristics of the spot and your individual needs. The latter in particular offers you an enormous advantage. Our training is divided into modules. This means you can be sure that the teaching content corresponds to your abilities, that rapid progress is guaranteed and that you only pay for what you really need. We hope we have made you curious and look forward to seeing you soon…'
    },
    // Kitesurfing Page
    kitesurfing: {
      title: 'Kitesurfing',
      subtitle: 'Wind and waves for perfect kiting',
      description: 'Soma Bay offers optimal conditions for kitesurfers. Constant winds and separate areas ensure a safe and unforgettable experience.',
      safety: 'Safety Areas',
      safety_desc: 'Separate zones for kiters and windsurfers',
      courses: 'Courses',
      courses_desc: 'From beginner to pro',
      rental: 'Rental',
      rental_desc: 'Top equipment for all levels',
      spot_title: 'Spot',
      spot_desc: 'We also offer a perfect spot for you kiters with plenty of space. On the windward side of our station, about 20 m from the beach, there is a 2 km long and about 600 m wide standing area, which becomes 30 cm to 60 cm deep depending on the tide. The waist-deep water ensures really pleasant and safe first kite attempts, first riding attempts, learning to go upwind or the first cool moves. At low tide, part of the sandbank is dry for about 2 ½ hours. But even during this time, you have an entire kite area behind the standing area for yourselves. Our kite storage offers plenty of storage options for your equipment. With our compressor, you can save yourself the pumping. And for setup and breakdown or just storage during breaks, you will find plenty of space without getting in the way of our surfers.',
      safety_title: 'Safety',
      safety_detail: 'Safety also takes a very important position with us. Due to the size of our spot, we were able to divide it into two areas: the beginner and teaching area and the freeride area. Furthermore, we divide it into the area for kitesurfers and windsurfers, so we can ensure that no one gets in each other\'s way, and the risk of accidents between kite and windsurfer is reduced to a minimum. If there are any difficulties, we are immediately on hand with our rescue boats.',
      school_title: 'Our School',
      school_desc: 'Do you want to learn kiting with fun and safety? Do you want professional support that is individually tailored to your needs? Then you are in the right place! Our kite school is located directly on the beach, one of the top spots in Egypt, which offers perfect conditions for kitesurfers of all skill levels. Here you can expect highly motivated kite instructors who care about your safety, well-being and learning success. Curious? Then take a look around…',
      courses_title: 'Our Courses',
      courses_detail: 'Our training is based on three points: The guidelines of VDWS and IKO, the special characteristics of the spot and your individual needs. The latter in particular offers you an enormous advantage. Our training is divided into modules. This means you can be sure that the teaching content corresponds to your abilities, that rapid progress is guaranteed and that you only pay for what you really need. We hope we have made you curious and look forward to seeing you soon.'
    },
    // Wingfoiling Page
    wingfoiling: {
      title: 'Wingfoiling',
      subtitle: 'The latest trend sport',
      description: 'Discover wingfoiling - the perfect combination of windsurfing, kitesurfing, and surfing. Ideal for anyone wanting to try something new.',
      learn: 'Learn',
      learn_desc: 'Quick start with our pros',
      gear: 'Gear',
      gear_desc: 'Latest wingfoiling equipment',
      about_title: 'The Wing Foil',
      about_desc: 'The Wing Foil is the latest development in board sports. A wing held with both hands is manipulated with a hydrofoil mounted on a short SUP board. It is a practice that sits between windsurf foil, kite foil and SUP foil. The wing is structured similarly to a kite, but is held directly on the body like in windsurfing. The most popular form is wing surfing with a foil board. Through an extension ("mast"), wings are attached to the board, through which the surfer lifts off the water at sufficient speed.',
      safety_title: 'Safety',
      safety_desc: 'Safety also takes a very important position with us. Due to the size of our spot, we were able to divide it into two areas: the beginner and teaching area and the freeride area. Furthermore, we divide it into the area for kitesurfers and windsurfers, so we can ensure that no one gets in each other\'s way, and the risk of accidents between kite and windsurfer is reduced to a minimum. If there are any difficulties, we are immediately on hand with our rescue boats.',
      school_title: 'Our School',
      school_desc: 'Do you want to learn wingfoiling with fun and safety? Do you want professional support that is individually tailored to your needs? Then you are in the right place! Our school is located directly on the beach, one of the top spots in Egypt, which offers perfect conditions for wing surfers, kite surfers, and windsurfers of all skill levels. Here you can expect highly motivated instructors who care about your safety, well-being and learning success. Curious? Then take a look around…',
      courses_title: 'Our Courses',
      courses_desc: 'Our training is based on three points: The guidelines of VDWS and IKO, the special characteristics of the spot and your individual needs. The latter in particular offers you an enormous advantage. Our training is divided into modules. This means you can be sure that the teaching content corresponds to your abilities, that rapid progress is guaranteed and that you only pay for what you really need. We hope we have made you curious and look forward to seeing you soon…'
    },
    // Center & Team
    center: {
      title: 'Center & Team',
      subtitle: 'More than just a watersports center',
      about: 'About Us',
      about_desc: 'Surfmotion Soma Bay is your premium center for windsurfing, kitesurfing, and wingfoiling. For years, we have been offering professional courses and top-quality equipment.',
      facilities: 'Our Facilities',
      facilities_desc: 'Modern equipment, changing rooms, showers, lounge area',
      team: 'Our Team',
      team_desc: 'Experienced and certified instructors'
    },
    // News Page
    newsPage: {
      title: 'News & Events',
      subtitle: 'Stay up to date',
      filter_all: 'All',
      filter_news: 'News',
      filter_events: 'Events',
      filter_updates: 'Updates',
      read_more: 'Read More',
      published_on: 'Published on'
    },
    // Hotels Page
    hotels: {
      title: 'Accommodation',
      subtitle: 'Our Partner Hotels in Soma Bay',
      description: 'We work with the best hotels in Soma Bay to provide you with the perfect stay.',
      amenities: 'Amenities',
      book_now: 'Book Now'
    },
    // Prices Page
    prices: {
      title: 'Prices',
      subtitle: 'Transparent prices for all activities',
      course: 'Course',
      rental: 'Rental',
      per_hour: 'per hour',
      per_day: 'per day',
      per_week: 'per week',
      beginner_course: 'Beginner Course',
      advanced_course: 'Advanced Course',
      private_lesson: 'Private Lesson',
      equipment_rental: 'Equipment Rental'
    },
    // Contact Page
    contact: {
      title: 'Contact',
      subtitle: 'We look forward to hearing from you',
      name: 'Name',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      send: 'Send',
      sending: 'Sending...',
      success: 'Message sent successfully!',
      error: 'Error sending message. Please try again.',
      info: 'Contact Information',
      address: 'Address',
      phone: 'Phone',
      email_label: 'Email'
    },
    // Booking Page
    booking: {
      title: 'Booking',
      subtitle: 'Book your watersports experience',
      activity: 'Activity',
      date: 'Date',
      level: 'Level',
      level_beginner: 'Beginner',
      level_intermediate: 'Intermediate',
      level_advanced: 'Advanced',
      phone: 'Phone (optional)',
      additional_info: 'Additional Information',
      submit: 'Request Booking',
      submitting: 'Submitting...',
      success: 'Booking request successful! We will contact you shortly.',
      error: 'Error submitting booking. Please try again.'
    },
    // Admin
    admin: {
      login: 'Login',
      username: 'Username',
      password: 'Password',
      login_button: 'Sign In',
      logout: 'Logout',
      dashboard: 'Dashboard',
      news_management: 'Manage News',
      bookings: 'Bookings',
      contacts: 'Contact Requests',
      images: 'Images',
      settings: 'Settings'
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      back: 'Back'
    }
  }
};

export const useTranslation = (lang = 'de') => {
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[lang];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };
  return { t };
};